import React from 'react';
import styled from '@emotion/styled';
import { links } from 'constants/external-links';
import TrackableLink from 'components/common/trackable-link';
import { EventNames } from 'utils/analytics.utils';
import { typeStyle } from 'constants/typography';

export const DrawerFooter: React.FC = () => {
  return (
    <Wrapper>
      <TrackableLink
        trackingData={{ eventName: EventNames.IN_APP_WHATS_NEW_VIEW_ALL_CLICKED }}
        url={links.docs.CHANGE_LOG.INDEX}
        messageId={'whats.new.view.all.releases'}
      />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  ${typeStyle.bodyLg}
  display: grid;
  place-items: center;
`;
